import Vue from 'vue'
import rssUi from '@rss/front-end_ui'

Vue.use(rssUi)
